interface IFeatureGatesIconProps {
  className?: string;
}

/**
 * Three vertical posts with a horizontal latch bar across the top — the gate
 * metaphor for the tool, deliberately literal so it reads at tile scale.
 * Monoline, `currentColor`, no fills. Designed on a 48×48 grid.
 */
const FeatureGatesIcon = ({ className }: IFeatureGatesIconProps) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 48 48"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    className={className}
    aria-hidden="true"
  >
    {/* horizontal latch bar */}
    <path d="M6 14 h36" />
    {/* three vertical posts */}
    <path d="M11 14 v28" />
    <path d="M24 14 v28" />
    <path d="M37 14 v28" />
    {/* angled cross-brace conveying motion / open state */}
    <path d="M11 22 l26 14" strokeOpacity="0.6" />
    {/* baseline so the gate "stands" on the ground */}
    <path d="M6 42 h36" strokeOpacity="0.4" />
  </svg>
);

export default FeatureGatesIcon;
